import { render, staticRenderFns } from "./CompanyDirector.vue?vue&type=template&id=02289775"
import script from "./CompanyDirector.vue?vue&type=script&lang=js"
export * from "./CompanyDirector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports